import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=606b5b7f&"
import script from "./TopHeader.vue?vue&type=script&lang=ts&"
export * from "./TopHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports